import { Content, Page } from '@backstage/core-components';
import Box from '@mui/material/Box';
import { ActionCards } from './ActionCards';
import { EphemeralJokeBanner } from './EphemeralJokeBanner';
import { HomeHero } from './HomeHero';
import { QuickLinksCard } from './QuickLinksCard';
import { RecentVisitsCard } from './RecentVisitsCard';
import { StarredCard } from './StarredCard';
import { YourSquadCard } from './YourSquadCard';
import { HOME_CONTENT_MAX_WIDTH } from './HomeCard';

// Curated, fixed-layout landing page rendered for every authenticated user:
// a paper hero (greeting + search) closed by the TE spectrum hairline, the
// three main journeys with live counts, then the personalized sections.
// All cards are MUI v5 on the shared theme; data comes from the catalog,
// visits and starred-entities APIs (see ./data.ts).
export const HomePage = () => (
  <Page themeId="home">
    <Content noPadding>
      <HomeHero />
      <Box sx={{ px: { xs: 2, md: 5 }, py: { xs: 2.25, md: 3.25 } }}>
        {/* Same centered frame as the hero, so both align on wide screens.
            CSS grid (not MUI Grid): no negative margins, so no horizontal
            overflow on mobile. */}
        <Box
          sx={{
            maxWidth: HOME_CONTENT_MAX_WIDTH,
            mx: 'auto',
            display: 'grid',
            gap: 2.25,
            gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' },
          }}
        >
          <Box sx={{ gridColumn: '1 / -1' }}>
            <ActionCards />
          </Box>
          <RecentVisitsCard />
          <YourSquadCard />
          <StarredCard />
          <QuickLinksCard />
        </Box>
      </Box>
      {/* Ephemeral random-joke toast: slides in at the bottom of the home
          body, gone after 5 s (hover pauses it). */}
      <EphemeralJokeBanner />
    </Content>
  </Page>
);
